import { render } from "./NumberModal.vue?vue&type=template&id=f84fd940&scoped=true"
import script from "./NumberModal.vue?vue&type=script&lang=js"
export * from "./NumberModal.vue?vue&type=script&lang=js"

import "./NumberModal.vue?vue&type=style&index=0&id=f84fd940&lang=css"
import "./NumberModal.vue?vue&type=style&index=1&id=f84fd940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f84fd940"]])

export default __exports__